import { render, staticRenderFns } from "./InvoiceCreator.vue?vue&type=template&id=35284e25&scoped=true"
import script from "./InvoiceCreator.vue?vue&type=script&lang=ts"
export * from "./InvoiceCreator.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceCreator.vue?vue&type=style&index=0&id=35284e25&prod&lang=scss&scoped=true"
import style1 from "./InvoiceCreator.vue?vue&type=style&index=1&id=35284e25&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "35284e25",
  null
  
)

export default component.exports